import React, {useContext} from 'react'
import {Route, Navigate} from "react-router";
import {AppContext} from "../../context/app-context";
import {withAccessControl} from "../ProtectedRoute";
import AccessControlBuilder from "../AccessControlBuilder";

import ServiceFeeApproval from "../../components/serviceFees/customer/ServiceFeeApproval";
import BookingPayment from '../../views/booking-payment/BookingPayment';
import BookingConfirmation from '../../views/booking-confirmation/BookingConfirmation';
import ReportOverview from "../../views/report-overview/ReportOverview";
import ExternalInvoice from '../../views/errors/ExternalInvoice';
import BuyerBooking from '../../views/booking-overview/BuyerBooking';
import BuyerInventoryCorrections
  from "../../views/inventory-correction/BuyerInventoryCorrections/BuyerInventoryCorrections";
import BookingMakePayment from "../../views/booking-payment/BookingMakePayment";

const allBuyerAuthorization = new AccessControlBuilder().allowAllBuyer().build();

const ProtectedPaymentPage = withAccessControl(BookingPayment, allBuyerAuthorization);
const ProtectedBookingConfirmation = withAccessControl(BookingConfirmation, allBuyerAuthorization);
const ProtectedBuyerInvoiceReport = withAccessControl(ServiceFeeApproval, allBuyerAuthorization);
const ProtectedReportOverview = withAccessControl(ReportOverview, allBuyerAuthorization);
const ProtectedBuyerBooking = withAccessControl(BuyerBooking, allBuyerAuthorization);
const ProtectedExternalInvoice = withAccessControl(ExternalInvoice, allBuyerAuthorization);
const ProtectedBuyerInventoryCorrections = withAccessControl(BuyerInventoryCorrections, allBuyerAuthorization);
const ProtectedBookingMakePayment = withAccessControl(BookingMakePayment, allBuyerAuthorization);

const BuyerContent = (): React.ReactElement<any>[] => {

  const appContext = useContext(AppContext)
  const {logout} = appContext

  return [
    <Route path="/my-bookings" key="/my-bookings" element={<Navigate to="/bookings"/>}>
    </Route>,
    <Route path="/location-profile/:profileId/payment" key="/booking-payment"
           element={<ProtectedPaymentPage handleLogout={logout}/>}>

    </Route>,
    <Route path="/booking-confirmation/:bookingId" key="/booking-confirmation"
           element={<ProtectedBookingConfirmation handleLogout={logout}/>}>

    </Route>,
    <Route path="/buyer-inventory" key="/buyer-inventory" element={<Navigate to='/reports/buyer-inventory'/>}>

    </Route>,
    <Route path="/buyer-interchanges" key="/buyer-interchanges"
           element={<Navigate to='/reports/interchanges'/>}></Route>,
    <Route path="/buyer-invoices" key="/buyer-invoices" element={<Navigate to='/reports/buyer-invoices'/>}></Route>,
    <Route path="/buyer-booked-space-calendar" key="/buyer-booked-space-calendar" element={
      <Navigate to="/reports/space-usage"/>
    }>
    </Route>,
    <Route path={"/buyer/service-fee/:transactionId"} key={"/buyer/service-fee/:transactionId"}
           element={<ProtectedBuyerInvoiceReport/>}>

    </Route>,
    <Route path="/reports/buyer-inventory" key="/reports/buyer-inventory"
           element={<ProtectedReportOverview handleLogout={logout} initialTab={0}/>}>

    </Route>,
    <Route path="/reports/interchanges" key="/reports/interchanges"
           element={<ProtectedReportOverview handleLogout={logout} initialTab={1}/>}></Route>,
    <Route path="/reports/buyer-invoices" key="/reports/buyer-invoices"
           element={<ProtectedReportOverview handleLogout={logout} initialTab={2}/>}></Route>,
    <Route path="/reports/space-usage" key="/reports/space-usage"
           element={<ProtectedReportOverview handleLogout={logout} initialTab={3}/>}></Route>,
    <Route path="/bookings" key="/bookings"
           element={
      <ProtectedBuyerBooking handleLogout={logout}/>}></Route>,
    <Route path="/buyer-invoice/:invoiceNumber" key="/invoice"
           element={<ProtectedExternalInvoice type="overage"/>}></Route>,
    <Route path="/buyer-inventory-corrections" key="/buyer-inventory-corrections" element={
      <ProtectedBuyerInventoryCorrections handleLogout={logout}/>
    }>
    </Route>,
    <Route path="/bookings/:bookingId/failedPayment" key="/invoice"
           element={
      <ProtectedBookingMakePayment handleLogout={logout}/>}></Route>,

  ]
}

export default BuyerContent
